import { createAction } from '@wix/communities-blog-client-common';

export const SET_LOCALE = 'locale/SET';

export const setLocale = createAction(SET_LOCALE);
